/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.pagebuilder.js
Source: slb_src/slices/page_builder/
Build: slb_build/build_page_builder.mjs
Built: 2026-09-19 16:53:59.981Z
Content-SHA256: d6c2284cb8832bca84ee13db79438baf7e9b320b229c6ee1863a8f1e0b7873cc
Content-SHA256-12: d6c2284cb883
*/

/* SLB Visual Page Builder (Admin) - Phase 2
   - Edits a small set of text/placeholder fields for common pages.
   - Persists to backend PAGE_CONFIG via adminPageCfgSave.
*/
(function(w){
  function el(id){ return document.getElementById(id); }
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function trim(s){ return String(s||"").trim(); }

  function toast(msg, ok){
    var t = el('slbPageBuilderToast');
    if(!t) return;
    t.textContent = msg||'';
    t.classList.remove('hidden');
    t.style.background = ok ? '#0f1517' : '#b00020';
    setTimeout(function(){ try{ t.classList.add('hidden'); }catch(_e){} }, 2400);
  }

  async function rpc(action, payload){
    payload = payload||{};
    // Wait briefly for core RPC to be ready (Shopify preview can delay scripts)
    for(let t=0;t<12;t++){
      if(w.rpc_) break;
      if(w.SLB_APP && w.SLB_APP.rpc) break;
      await new Promise(res=>setTimeout(res,150));
    }
    if(w.rpc_) return w.rpc_(action, payload);
    if(w.SLB_APP && w.SLB_APP.rpc) return w.SLB_APP.rpc(action, payload);
    throw new Error('RPC not available');
  }



  // Global builder state (Phase 3)
  var PB_STATE = {
    pageKey: '',
    cfg: null
  };



  // ============================
  // Phase 2: Visual Picker Overlay
  // - Admin can click any element on the current SLB page to capture a stable selector.
  // - Saves selector-based overrides into cfg.selectors (safe: textContent + placeholders only).
  // ============================

  var PB_PICK = {
    enabled:false,
    pageKey:'',
    cfg:null,
    hoverEl:null,
    lastSel:'',
    floatEl:null
  };

  function cssEsc(s){
    s = String(s||'');
    if(w.CSS && CSS.escape) return CSS.escape(s);
    return s.replace(/[^a-zA-Z0-9_\-]/g, function(ch){ return '\\' + ch; });
  }

  function buildNthSelector(el, root){
    if(!el || el===root) return '';
    var parts = [];
    var cur = el;
    while(cur && cur !== root && cur.nodeType===1){
      var tag = cur.tagName.toLowerCase();
      // Prefer id if unique
      var id = cur.getAttribute && cur.getAttribute('id');
      if(id){
        var sid = '#' + cssEsc(id);
        try{
          if(root.querySelectorAll(sid).length===1){
            parts.unshift(sid);
            break;
          }
        }catch(_e){}
      }
      // nth-of-type path
      var parent = cur.parentElement;
      if(!parent) break;
      var same = Array.prototype.filter.call(parent.children, function(x){ return x.tagName===cur.tagName; });
      var idx = same.indexOf(cur) + 1;
      parts.unshift(tag + ':nth-of-type(' + idx + ')');
      cur = parent;
    }
    return parts.join(' > ');
  }

  function pickSelectorFor(el){
    var root = document.getElementById('SaamLawBank') || document.querySelector('#SaamLawBank');
    if(!root) return '';
    if(!root.contains(el)) return '';
    var sel = buildNthSelector(el, root);
    if(!sel) return '';
    // return selector relative to #SaamLawBank for safe scoping in applier
    if(sel.indexOf('#SaamLawBank')===0) return sel;
    return sel;
  }

  
  // Determine current pageKey based on the visible panel (so Picker saves to the correct page)
  function getVisiblePanelId(){
    try{
      var root = document.getElementById('SaamLawBank') || document.querySelector('#SaamLawBank') ||
                 document.getElementById('tyWealthCourtyard') || document.querySelector('#tyWealthCourtyard');
      if(!root) return '';
      var p = root.querySelector('.panel[data-panel]:not(.hidden)');
      return p ? String(p.getAttribute('data-panel')||'').trim() : '';
    }catch(_e){ return ''; }
  }
  function panelIdToPageKey(panelId){
    panelId = String(panelId||'').trim();
    if(!panelId) return '';
    // Only the initial Builder pages in Phase 1–3
    if(panelId === 'deposit') return 'Deposit';
    if(panelId === 'withdraw') return 'Withdraw';
    if(panelId === 'gift') return 'Gift';
    if(panelId === 'user') return 'User';
    return '';
  }
  function resolveActivePageKey(fallback){
    return panelIdToPageKey(getVisiblePanelId()) || String(fallback||'').trim() || '';
  }

function isBadPickTarget(node){
    if(!node || node.nodeType!==1) return true;
    // do not allow selecting the builder panel itself or any fixed overlay
    try{
      if(node.closest && node.closest('#slbPageBuilder')) return true;
      if(node.closest && node.closest('#slbPbFloat')) return true;
    }catch(_e){}
    var tag = (node.tagName||'').toLowerCase();
    if(tag==='script' || tag==='style' || tag==='link' || tag==='meta') return true;
    return false;
  }

  function setHoverOutline(el){
    try{
      if(PB_PICK.hoverEl && PB_PICK.hoverEl!==el){
        PB_PICK.hoverEl.style.outline = '';
        PB_PICK.hoverEl.style.outlineOffset = '';
      }
    }catch(_e){}
    PB_PICK.hoverEl = el;
    try{
      if(el){
        el.style.outline = '2px solid #ef5e14';
        el.style.outlineOffset = '2px';
      }
    }catch(_e2){}
  }

  function ensureFloat(){
    if(PB_PICK.floatEl) return PB_PICK.floatEl;
    var box = document.createElement('div');
    box.id = 'slbPbFloat';
    box.style.position = 'fixed';
    box.style.right = '14px';
    box.style.bottom = '14px';
    box.style.zIndex = '99999';
    box.style.width = '320px';
    box.style.maxWidth = '92vw';
    box.style.background = '#f7f7f7';
    box.style.border = '1px solid #e2e6ea';
    box.style.borderRadius = '14px';
    box.style.boxShadow = '0 10px 25px rgba(0,0,0,.18)';
    box.style.padding = '10px';
    box.style.fontSize = '12px';
    box.style.display = 'none';
    box.innerHTML = ''+
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">'+
        '<div style="font-weight:900;">Picker</div>'+
        '<button type="button" id="slbPbFloatClose" class="slb-btn slb-btn--grey" style="padding:6px 10px;">Stop</button>'+
      '</div>'+
      '<div style="margin-top:6px;opacity:.85;">Click an element on the page to capture it.</div>'+
      '<div style="margin-top:8px;">'+
        '<div style="font-weight:800;margin-bottom:4px;">Selected</div>'+
        '<div id="slbPbFloatSel" style="font-family:monospace;font-size:11px;max-height:52px;overflow:auto;background:#fff;border:1px solid #e2e6ea;border-radius:10px;padding:6px;"></div>'+
      '</div>'+
      '<div style="margin-top:8px;">'+
        '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">'+
          '<div style="font-weight:800;">Mode</div>'+
          '<select id="slbPbFloatMode" style="padding:6px 8px;border:1px solid #e2e6ea;border-radius:10px;background:#fff;">'+
            '<option value="text">Text</option>'+
            '<option value="ph">Placeholder</option>'+
            '<option value="block">Block</option>'+
            '<option value="button">Button</option>'+
          '</select>'+
        '</div>'+
        '<div style="margin-top:8px;">'+
          '<div style="font-weight:800;margin-bottom:4px;">Value</div>'+
          '<input id="slbPbFloatVal" type="text" style="width:100%;padding:9px 10px;border:1px solid #e2e6ea;border-radius:10px;" />'+
          '<div style="display:flex;gap:8px;margin-top:8px;">'+
            '<button type="button" id="slbPbFloatSaveText" class="slb-btn slb-btn--orange" style="flex:1;padding:9px 10px;">Save Text</button>'+
            '<button type="button" id="slbPbFloatSavePh" class="slb-btn slb-btn--white" style="flex:1;padding:9px 10px;">Save Placeholder</button>'+
          '</div>'+
        '</div>'+
        '<div style="margin-top:10px;padding-top:10px;border-top:1px dashed #e2e6ea;">'+
          '<div style="font-weight:900;margin-bottom:6px;">Block</div>'+
          '<input id="slbPbFloatBlkName" type="text" placeholder="Block name (eg. Top Title)" style="width:100%;padding:9px 10px;border:1px solid #e2e6ea;border-radius:10px;" />'+
          '<div style="display:flex;gap:8px;align-items:center;margin-top:8px;flex-wrap:wrap;">'+
            '<label style="display:flex;align-items:center;gap:6px;"><input id="slbPbFloatBlkShow" type="checkbox" checked /> Show</label>'+
            '<select id="slbPbFloatBlkPreset" style="padding:6px 8px;border:1px solid #e2e6ea;border-radius:10px;background:#fff;">'+
              '<option value="none">Preset: none</option>'+
              '<option value="orange">Preset: orange</option>'+
              '<option value="grey">Preset: grey</option>'+
            '</select>'+
            '<button type="button" id="slbPbFloatSaveBlk" class="slb-btn slb-btn--grey" style="margin-left:auto;padding:8px 10px;">Save Block</button>'+
          '</div>'+
        '</div>'+
        '<div style="margin-top:10px;padding-top:10px;border-top:1px dashed #e2e6ea;">'+
          '<div style="font-weight:900;margin-bottom:6px;">Button</div>'+
          '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">'+
            '<select id="slbPbFloatBtnColor" style="flex:1;min-width:140px;padding:8px 10px;border:1px solid #e2e6ea;border-radius:10px;background:#fff;">'+
              '<option value="orange">orange</option>'+
              '<option value="red">red</option>'+
              '<option value="black">black</option>'+
              '<option value="blue">blue</option>'+
              '<option value="white">white</option>'+
              '<option value="grey">grey</option>'+
            '</select>'+
            '<button type="button" id="slbPbFloatSaveBtn" class="slb-btn slb-btn--blue" style="padding:8px 10px;">Save Button</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(box);
    PB_PICK.floatEl = box;

    function byId(x){ return document.getElementById(x); }
    byId('slbPbFloatClose').addEventListener('click', function(){ stopPickMode(); });
    byId('slbPbFloatSaveText').addEventListener('click', function(){ savePicked('text'); });
    byId('slbPbFloatSavePh').addEventListener('click', function(){ savePicked('ph'); });
    try{ byId('slbPbFloatSaveBlk').addEventListener('click', function(){ savePickedBlock(); }); }catch(_e){}
    try{ byId('slbPbFloatSaveBtn').addEventListener('click', function(){ savePickedButton(); }); }catch(_e2){}
    return box;
  }

  function showFloat(show){
    var box = ensureFloat();
    box.style.display = show ? 'block' : 'none';
  }

  function startPickMode(pageKey, cfg){
    PB_PICK.enabled = true;
    PB_PICK.pageKey = String(pageKey||'').trim();
    PB_PICK.cfg = cfg || null;
    PB_PICK.lastSel = '';
    setHoverOutline(null);
    showFloat(true);
    toast('Picker ON: hold ALT + click to pick (normal click navigates)', true);

    document.addEventListener('mouseover', onPickHover, true);
    document.addEventListener('click', onPickClick, true);
    document.addEventListener('keydown', onPickKey, true);
  }

  function stopPickMode(){
    PB_PICK.enabled = false;
    PB_PICK.pageKey = '';
    PB_PICK.cfg = null;
    PB_PICK.lastSel = '';
    try{ document.removeEventListener('mouseover', onPickHover, true); }catch(_e){}
    try{ document.removeEventListener('click', onPickClick, true); }catch(_e2){}
    try{ document.removeEventListener('keydown', onPickKey, true); }catch(_e3){}
    setHoverOutline(null);
    showFloat(false);
    toast('Picker OFF', true);
  }

  function onPickKey(e){
    if(!PB_PICK.enabled) return;
    if(e && (e.key==='Escape' || e.key==='Esc')){
      e.preventDefault(); e.stopPropagation();
      stopPickMode();
    }
  }

  function onPickHover(e){
    if(!PB_PICK.enabled) return;
    var t = e && e.target;
    if(isBadPickTarget(t)) return;
    setHoverOutline(t);
  }

  function onPickClick(e){
    if(!PB_PICK.enabled) return;
    // IMPORTANT: allow normal navigation while Picker is ON.
    // Hold ALT and click to capture. Normal click behaves normally.
    if(!(e && e.altKey)) return;
    var t = e && e.target;
    if(isBadPickTarget(t)) return;
    e.preventDefault(); e.stopPropagation();

    var sel = pickSelectorFor(t);
    if(!sel){
      toast('Could not capture selector', false);
      return;
    }
    PB_PICK.lastSel = sel;

    var selBox = document.getElementById('slbPbFloatSel');
    if(selBox) selBox.textContent = sel;

    var val = '';
    try{
      if(t && (t.tagName==='INPUT' || t.tagName==='TEXTAREA')) val = t.getAttribute('placeholder') || '';
      else val = (t.textContent || '').trim();
    }catch(_e){}
    var inp = document.getElementById('slbPbFloatVal');
    if(inp) inp.value = val;
    toast('Captured. Enter new text then Save.', true);
  }

  async function savePicked(kind){
    if(!PB_PICK.enabled) return;
    var sel = PB_PICK.lastSel;
    if(!sel){ toast('Pick an element first', false); return; }

    var inp = document.getElementById('slbPbFloatVal');
    var val = inp ? String(inp.value||'') : '';
    if(!val.trim()){ toast('Empty value (not saved)', false); return; }

    var cfg = PB_PICK.cfg || emptyCfg();
    if(!Array.isArray(cfg.selectors)) cfg.selectors = [];
    cfg.selectors.push({ sel: sel, kind: kind, value: val });
    // optimistic apply so you instantly see the change
    try{
      var root = document.getElementById('SaamLawBank') || document.querySelector('#SaamLawBank') ||
                 document.getElementById('tyWealthCourtyard') || document.querySelector('#tyWealthCourtyard');
      if(root){
        var qsel = sel;
        if(qsel.indexOf('#SaamLawBank')!==0 && qsel.indexOf('#tyWealthCourtyard')!==0){
          // scope within SLB root
          qsel = '#SaamLawBank ' + qsel;
        }
        var node = null;
        try{ node = document.querySelector(qsel); }catch(_qe){ node=null; }
        if(node){
          if(String(kind||'text').toLowerCase()==='ph'){ node.setAttribute('placeholder', val); }
          else { node.textContent = val; }
        }
      }
    }catch(_eOpt){}


    // save immediately
    try{
      var requestId = 'PBSEL_' + Math.random().toString(36).slice(2) + Date.now();
      var r = await rpc('adminPageCfgSave', { pageKey: resolveActivePageKey(PB_PICK.pageKey), config: cfg, requestId: requestId });
      PB_PICK.cfg = cfg;
      toast('Saved selector (v' + (r && r.version ? r.version : '?') + ')', true);
      try{ if(w.SLB_applyPageCfgPreview) w.SLB_applyPageCfgPreview(resolveActivePageKey(PB_PICK.pageKey), cfg); }catch(_e2){}
    }catch(e){
      console.error(e);
      toast('Save selector failed', false);
    }
  }

  var SCHEMA = {
    deposit: [
      { key:'deposit.confirmTitle', label:'Deposit - Top title (Confirm Amount)', type:'text' },
      { key:'deposit.confirmBtn', label:'Deposit - Confirm button text', type:'text' },
      { key:'deposit.notePh', label:'Deposit - Note placeholder', type:'text' }
    ],
    withdraw: [
      { key:'withdraw.confirmTitle', label:'Withdrawal - Top title (Confirm Amount)', type:'text' },
      { key:'withdraw.confirmBtn', label:'Withdrawal - Confirm button text', type:'text' },
      { key:'withdraw.notePh', label:'Withdrawal - Note placeholder', type:'text' }
    ],
    gift: [
      { key:'gift.confirmTitle', label:'Gift - Top title (Confirm Amount)', type:'text' },
      { key:'gift.confirmBtn', label:'Gift - Confirm button text', type:'text' }
    ],
    user: [
      { key:'user.pinHeading', label:'User - Heading: Changing PIN', type:'text' },
      { key:'user.pinNote', label:'User - Note under PIN heading', type:'text' },
      { key:'user.changePinBtn', label:'User - Button: Change PIN', type:'text' },
      { key:'user.pinResetBtn', label:'User - Button: Request PIN reset', type:'text' },
      { key:'user.emailHeading', label:'User - Heading: Email Notifications', type:'text' },
      { key:'user.emailNote', label:'User - Note under Email heading', type:'text' }
    ]
  };

  async function savePickedBlock(){
    if(!PB_PICK.enabled) return;
    var sel = PB_PICK.lastSel;
    if(!sel){ toast('Pick an element first', false); return; }

    var name = '';
    try{ name = String(document.getElementById('slbPbFloatBlkName').value||'').trim(); }catch(_e){}
    if(!name) name = 'Block';

    var enabled = true;
    try{ enabled = !!document.getElementById('slbPbFloatBlkShow').checked; }catch(_e2){ enabled = true; }

    var preset = 'none';
    try{ preset = String(document.getElementById('slbPbFloatBlkPreset').value||'none').trim(); }catch(_e3){ preset='none'; }

    var cfg = PB_PICK.cfg || emptyCfg();
    if(!Array.isArray(cfg.blocks)) cfg.blocks = [];

    // if same selector already exists, update it
    var found = false;
    for(var i=0;i<cfg.blocks.length;i++){
      if(cfg.blocks[i] && String(cfg.blocks[i].sel||'') === sel){
        cfg.blocks[i].name = name;
        cfg.blocks[i].enabled = enabled;
        cfg.blocks[i].preset = preset;
        found = true;
        break;
      }
    }
    if(!found) cfg.blocks.push({ sel: sel, name: name, enabled: enabled, preset: preset });

    try{
      var requestId = 'PBBLK_' + Math.random().toString(36).slice(2) + Date.now();
      var r = await rpc('adminPageCfgSave', { pageKey: resolveActivePageKey(PB_PICK.pageKey), config: cfg, requestId: requestId });
      PB_PICK.cfg = cfg;
      PB_STATE.pageKey = PB_PICK.pageKey;
      PB_STATE.cfg = cfg;
      try{ buildForm(resolveActivePageKey(PB_PICK.pageKey), cfg); }catch(_e4){}
      toast('Saved block (v' + (r && r.version ? r.version : '?') + ')', true);
      try{ if(w.SLB_applyPageCfgPreview) w.SLB_applyPageCfgPreview(resolveActivePageKey(PB_PICK.pageKey), cfg); }catch(_e5){}
    }catch(e){
      console.error(e);
      toast('Save block failed', false);
    }
  }

  async function savePickedButton(){
    if(!PB_PICK.enabled) return;
    var sel = PB_PICK.lastSel;
    if(!sel){ toast('Pick an element first', false); return; }

    var color = 'grey';
    try{ color = String(document.getElementById('slbPbFloatBtnColor').value||'grey').trim(); }catch(_e){}
    if(!color) color = 'grey';

    var cfg = PB_PICK.cfg || emptyCfg();
    if(!Array.isArray(cfg.buttons)) cfg.buttons = [];

    var found = false;
    for(var i=0;i<cfg.buttons.length;i++){
      if(cfg.buttons[i] && String(cfg.buttons[i].sel||'') === sel){
        cfg.buttons[i].color = color;
        found = true;
        break;
      }
    }
    if(!found) cfg.buttons.push({ sel: sel, color: color });

    try{
      var requestId = 'PBBTN_' + Math.random().toString(36).slice(2) + Date.now();
      var r = await rpc('adminPageCfgSave', { pageKey: resolveActivePageKey(PB_PICK.pageKey), config: cfg, requestId: requestId });
      PB_PICK.cfg = cfg;
      PB_STATE.pageKey = PB_PICK.pageKey;
      PB_STATE.cfg = cfg;
      try{ buildForm(resolveActivePageKey(PB_PICK.pageKey), cfg); }catch(_e2){}
      toast('Saved button (v' + (r && r.version ? r.version : '?') + ')', true);
      try{ if(w.SLB_applyPageCfgPreview) w.SLB_applyPageCfgPreview(resolveActivePageKey(PB_PICK.pageKey), cfg); }catch(_e3){}
    }catch(e){
      console.error(e);
      toast('Save button failed', false);
    }
  }


  function emptyCfg(){
    return { text: Object.create(null), show: Object.create(null), selectors: [], blocks: [], buttons: [] };
  }

  function getDefaultsForPage(pageKey){
    var out = emptyCfg();
    var panel = q('[data-panel="'+pageKey+'"]');
    var fields = SCHEMA[pageKey] || [];
    fields.forEach(function(f){
      var k = f.key;
      if(f.key.endsWith('.notePh')){
        var inp = q('[data-slp-ph="'+k+'"]', panel||document);
        if(inp && inp.getAttribute) out.text[k] = inp.getAttribute('placeholder') || '';
      } else {
        var node = q('[data-slp-text="'+k+'"]', panel||document);
        if(node) out.text[k] = (node.textContent||'').trim();
      }
    });
    return out;
  }

  function buildForm(pageKey, cfg){
    var host = el('slbPageBuilderForm');
    if(!host) return;
    host.innerHTML = '';

    var fields = SCHEMA[pageKey] || [];
    if(!fields.length){
      host.innerHTML = '<div class="note">No fields for this page yet.</div>';
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'pbGrid';

    fields.forEach(function(f){
      var wrap = document.createElement('div');
      wrap.className = 'pbField';
      var h = document.createElement('div');
      h.className = 'h';
      h.textContent = f.label;
      wrap.appendChild(h);

      var input = document.createElement('input');
      input.className = 'inp';
      input.type = 'text';
      input.setAttribute('data-pb-key', f.key);
      input.value = (cfg && cfg.text && (cfg.text[f.key] != null)) ? String(cfg.text[f.key]) : '';
      wrap.appendChild(input);
      grid.appendChild(wrap);
    });

    
    host.appendChild(grid);

    // ===== Phase 3 panels =====
    var cfgSafe = cfg || emptyCfg();

    // Selector overrides list
    var panelSel = document.createElement('div');
    panelSel.className = 'pbField';
    panelSel.innerHTML = '<div class="h">Selector Overrides</div>'+
      '<div style="font-size:12px;opacity:.85;margin-bottom:6px;">These are created by the Picker (text / placeholder).</div>'+
      '<div id="slbPbSelList" style="display:flex;flex-direction:column;gap:6px;"></div>';
    host.appendChild(panelSel);

    // Blocks list
    var panelBlk = document.createElement('div');
    panelBlk.className = 'pbField';
    panelBlk.innerHTML = '<div class="h">Blocks (Show/Hide + Preset)</div>'+
      '<div style="font-size:12px;opacity:.85;margin-bottom:6px;">Use Picker mode “Block” to add a block. Then you can toggle it here.</div>'+
      '<div id="slbPbBlkList" style="display:flex;flex-direction:column;gap:6px;"></div>';
    host.appendChild(panelBlk);

    // Buttons list
    var panelBtn = document.createElement('div');
    panelBtn.className = 'pbField';
    panelBtn.innerHTML = '<div class="h">Buttons (Color Override)</div>'+
      '<div style="font-size:12px;opacity:.85;margin-bottom:6px;">Use Picker mode “Button” to set a button to global orange/red/blue/etc.</div>'+
      '<div id="slbPbBtnList" style="display:flex;flex-direction:column;gap:6px;"></div>';
    host.appendChild(panelBtn);

    // Export / Import
    var panelX = document.createElement('div');
    panelX.className = 'pbField';
    panelX.innerHTML = '<div class="h">Export / Import</div>'+
      '<div class="row" style="gap:8px;flex-wrap:wrap;margin-top:6px;">'+
        '<button class="btn" id="slbPbExportPage" type="button">Export this page</button>'+
        '<button class="btn" id="slbPbExportAll" type="button">Export ALL</button>'+
        '<button class="btn soft" id="slbPbImportPage" type="button">Import (this page)</button>'+
        '<button class="btn soft" id="slbPbImportAll" type="button">Import (ALL)</button>'+
      '</div>'+
      '<div style="margin-top:8px;font-size:12px;opacity:.85;">Paste JSON below for import, or export will fill it for copy/paste backup.</div>'+
      '<textarea id="slbPbXfer" style="width:100%;min-height:120px;margin-top:8px;padding:10px;border:1px solid #e2e6ea;border-radius:12px;font-family:monospace;font-size:12px;"></textarea>';
    host.appendChild(panelX);

    // render lists
    renderLists_(pageKey, cfgSafe);

    // bind export/import
    bindXfer_(pageKey);

  }

  
  function escapeHtml_(s){
    return String(s||'').replace(/[&<>"']/g, function(ch){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch] || ch);
    });
  }

  function renderLists_(pageKey, cfg){
    cfg = cfg || emptyCfg();

    // selectors
    try{
      var host = el('slbPbSelList');
      if(host){
        host.innerHTML = '';
        var arr = Array.isArray(cfg.selectors) ? cfg.selectors : [];
        if(!arr.length){
          host.innerHTML = '<div style="opacity:.7;">(none)</div>';
        }else{
          arr.slice(0,80).forEach(function(r, idx){
            var row = document.createElement('div');
            row.style.display='flex';
            row.style.gap='8px';
            row.style.alignItems='center';
            row.style.flexWrap='wrap';
            row.innerHTML =
              '<div style="flex:1;min-width:180px;font-family:monospace;font-size:11px;opacity:.85;">'+escapeHtml_(r.sel||'')+'</div>'+
              '<div style="font-weight:800;font-size:11px;">'+escapeHtml_((r.kind||'text').toUpperCase())+'</div>'+
              '<button class="btn soft" type="button" data-rm-sel="'+idx+'">Remove</button>';
            host.appendChild(row);
          });
          host.querySelectorAll('button[data-rm-sel]').forEach(function(b){
            b.addEventListener('click', function(){
              var i = Number(b.getAttribute('data-rm-sel'));
              if(!Array.isArray(cfg.selectors)) cfg.selectors = [];
              cfg.selectors.splice(i,1);
              PB_STATE.cfg = cfg;
              buildForm(pageKey, cfg);
            });
          });
        }
      }
    }catch(_e){}

    // blocks
    try{
      var hostB = el('slbPbBlkList');
      if(hostB){
        hostB.innerHTML = '';
        var barr = Array.isArray(cfg.blocks) ? cfg.blocks : [];
        if(!barr.length){
          hostB.innerHTML = '<div style="opacity:.7;">(none)</div>';
        }else{
          barr.slice(0,80).forEach(function(b, idx){
            var row = document.createElement('div');
            row.style.display='flex';
            row.style.gap='8px';
            row.style.alignItems='center';
            row.style.flexWrap='wrap';

            var name = b.name || ('Block ' + (idx+1));
            var enabled = (b.enabled === undefined || b.enabled === null) ? true : !!b.enabled;
            var preset = (b.preset||'none');

            row.innerHTML =
              '<div style="flex:1;min-width:160px;font-weight:800;">'+escapeHtml_(name)+'</div>'+
              '<label style="display:flex;align-items:center;gap:6px;font-size:12px;"><input type="checkbox" data-blk-en="'+idx+'" '+(enabled?'checked':'')+'/> Show</label>'+
              '<select class="inp" style="min-width:120px;" data-blk-pre="'+idx+'">'+
                '<option value="none">Preset: none</option>'+
                '<option value="orange">Preset: orange</option>'+
                '<option value="grey">Preset: grey</option>'+
              '</select>'+
              '<button class="btn soft" type="button" data-rm-blk="'+idx+'">Remove</button>';

            hostB.appendChild(row);

            // set select value
            try{
              var sel = row.querySelector('select[data-blk-pre="'+idx+'"]');
              if(sel) sel.value = (preset==='gray'?'grey':preset);
            }catch(_s){}
          });

          hostB.querySelectorAll('input[data-blk-en]').forEach(function(inp){
            inp.addEventListener('change', function(){
              var i = Number(inp.getAttribute('data-blk-en'));
              if(!Array.isArray(cfg.blocks)) cfg.blocks = [];
              if(!cfg.blocks[i]) return;
              cfg.blocks[i].enabled = !!inp.checked;
              PB_STATE.cfg = cfg;
            });
          });
          hostB.querySelectorAll('select[data-blk-pre]').forEach(function(sel){
            sel.addEventListener('change', function(){
              var i = Number(sel.getAttribute('data-blk-pre'));
              if(!Array.isArray(cfg.blocks)) cfg.blocks = [];
              if(!cfg.blocks[i]) return;
              cfg.blocks[i].preset = String(sel.value||'none');
              PB_STATE.cfg = cfg;
            });
          });
          hostB.querySelectorAll('button[data-rm-blk]').forEach(function(btn){
            btn.addEventListener('click', function(){
              var i = Number(btn.getAttribute('data-rm-blk'));
              if(!Array.isArray(cfg.blocks)) cfg.blocks = [];
              cfg.blocks.splice(i,1);
              PB_STATE.cfg = cfg;
              buildForm(pageKey, cfg);
            });
          });
        }
      }
    }catch(_be){}

    // buttons
    try{
      var hostC = el('slbPbBtnList');
      if(hostC){
        hostC.innerHTML = '';
        var carr = Array.isArray(cfg.buttons) ? cfg.buttons : [];
        if(!carr.length){
          hostC.innerHTML = '<div style="opacity:.7;">(none)</div>';
        }else{
          carr.slice(0,80).forEach(function(b, idx){
            var row = document.createElement('div');
            row.style.display='flex';
            row.style.gap='8px';
            row.style.alignItems='center';
            row.style.flexWrap='wrap';

            var color = (b.color||'grey');
            row.innerHTML =
              '<div style="flex:1;min-width:180px;font-family:monospace;font-size:11px;opacity:.85;">'+escapeHtml_(b.sel||'')+'</div>'+
              '<select class="inp" style="min-width:110px;" data-btn-col="'+idx+'">'+
                '<option value="orange">orange</option>'+
                '<option value="red">red</option>'+
                '<option value="black">black</option>'+
                '<option value="blue">blue</option>'+
                '<option value="white">white</option>'+
                '<option value="grey">grey</option>'+
              '</select>'+
              '<button class="btn soft" type="button" data-rm-btn="'+idx+'">Remove</button>';

            hostC.appendChild(row);
            try{
              var sel = row.querySelector('select[data-btn-col="'+idx+'"]');
              if(sel) sel.value = (color==='gray'?'grey':color);
            }catch(_s2){}
          });

          hostC.querySelectorAll('select[data-btn-col]').forEach(function(sel){
            sel.addEventListener('change', function(){
              var i = Number(sel.getAttribute('data-btn-col'));
              if(!Array.isArray(cfg.buttons)) cfg.buttons = [];
              if(!cfg.buttons[i]) return;
              cfg.buttons[i].color = String(sel.value||'grey');
              PB_STATE.cfg = cfg;
            });
          });
          hostC.querySelectorAll('button[data-rm-btn]').forEach(function(btn){
            btn.addEventListener('click', function(){
              var i = Number(btn.getAttribute('data-rm-btn'));
              if(!Array.isArray(cfg.buttons)) cfg.buttons = [];
              cfg.buttons.splice(i,1);
              PB_STATE.cfg = cfg;
              buildForm(pageKey, cfg);
            });
          });
        }
      }
    }catch(_ce){}
  }

  function downloadJson_(filename, obj){
    var blob = new Blob([JSON.stringify(obj, null, 2)], {type:'application/json'});
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(_e){} try{ a.remove(); }catch(_e2){} }, 400);
  }

  function bindXfer_(pageKey){
    var ta = el('slbPbXfer');
    var b1 = el('slbPbExportPage');
    var b2 = el('slbPbExportAll');
    var b3 = el('slbPbImportPage');
    var b4 = el('slbPbImportAll');
    if(!ta || !b1 || !b2 || !b3 || !b4) return;

    b1.onclick = function(){
      var cfg = PB_STATE.cfg || emptyCfg();
      ta.value = JSON.stringify({ pageKey: pageKey, config: cfg }, null, 2);
      downloadJson_('slb_pagecfg_'+pageKey+'.json', { pageKey: pageKey, config: cfg });
      toast('Exported this page', true);
    };

    b2.onclick = async function(){
      try{
        var r = await rpc('adminPageCfgExportAll', {});
        if(r && r.ok && r.items){
          ta.value = JSON.stringify({ items: r.items }, null, 2);
          downloadJson_('slb_pagecfg_ALL.json', { items: r.items });
          toast('Exported ALL configs', true);
        }else{
          toast('Export ALL failed', false);
        }
      }catch(e){
        toast('Export ALL error: '+(e&&e.message?e.message:e), false);
      }
    };

    b3.onclick = function(){
      try{
        var obj = JSON.parse(String(ta.value||''));
        var cfg = null;
        if(obj && obj.pageKey && obj.config) cfg = obj.config;
        else if(obj && obj.config) cfg = obj.config;
        else cfg = obj;
        if(!cfg) throw new Error('No config found in JSON');
        PB_STATE.cfg = cfg;
        buildForm(pageKey, cfg);
        toast('Imported to builder (click Save to persist)', true);
      }catch(e){
        toast('Import error: '+(e&&e.message?e.message:e), false);
      }
    };

    b4.onclick = async function(){
      try{
        var obj = JSON.parse(String(ta.value||''));
        var items = obj && obj.items ? obj.items : null;
        if(!items || !Array.isArray(items)) throw new Error('Missing items[]');
        var requestId = 'PBIMP_' + Math.random().toString(36).slice(2);
        var r = await rpc('adminPageCfgImportAll', { items: items, requestId: requestId });
        if(r && r.ok){
          toast('Imported ALL (imported '+(r.imported||0)+', failed '+(r.failed||0)+')', true);
        }else{
          toast('Import ALL failed', false);
        }
      }catch(e){
        toast('Import ALL error: '+(e&&e.message?e.message:e), false);
      }
    };
  }

function readFormIntoCfg(pageKey, baseCfg){
    var cfg = baseCfg ? JSON.parse(JSON.stringify(baseCfg)) : emptyCfg();
    if(!cfg.text) cfg.text = Object.create(null);

    qa('#slbPageBuilderForm [data-pb-key]').forEach(function(inp){
      var k = inp.getAttribute('data-pb-key');
      cfg.text[k] = String(inp.value||'');
    });
    return cfg;
  }

  function setStatus(s){
    var st = el('slbPageBuilderStatus');
    if(st) st.textContent = s||'Ready';
  }

  function isAdminOrMod(){
    try{
      return (sessionStorage.getItem('tyw_isAdmin')==='1') || (sessionStorage.getItem('tyw_isModerator')==='1');
    }catch(_e){
      return false;
    }
  }

  function initOnce(){
    var root = el('slbPageBuilder');
    if(!root) return;
    if(root.getAttribute('data-init')==='1') return;
    root.setAttribute('data-init','1');

    if(!isAdminOrMod()){
      root.innerHTML = '<div class="note">Admin/Moderator only.</div>';
      return;
    }

    var sel = el('slbPageBuilderPageSel');
    if(sel){
      ['deposit','withdraw','gift','user','accounts'].forEach(function(k){
        var o = document.createElement('option');
        o.value = k;
        o.textContent = ({deposit:'Deposit', withdraw:'Withdrawal', gift:'Gift', user:'User', accounts:'Cosmic Pouch'})[k] || k;
        sel.appendChild(o);
      });
    }

    var curCfg = null;

    async function doLoad(){
      var pageKey = sel ? sel.value : 'deposit';
      setStatus('Loading…');
      try{
        var r = await rpc('pageCfgGet', { pageKey: pageKey });
        curCfg = (r && r.config) ? r.config : null;
        if(curCfg){ if(!curCfg.text) curCfg.text = Object.create(null); if(!curCfg.show) curCfg.show = Object.create(null); if(!Array.isArray(curCfg.selectors)) curCfg.selectors = []; if(!Array.isArray(curCfg.blocks)) curCfg.blocks = []; if(!Array.isArray(curCfg.buttons)) curCfg.buttons = []; }
        if(!curCfg) curCfg = getDefaultsForPage(pageKey);
        PB_STATE.pageKey = pageKey;
        PB_STATE.cfg = curCfg;
        buildForm(pageKey, curCfg);
        setStatus('Loaded');
      }catch(e){
        console.error(e);
        // Fallback to defaults so builder still works even if backend sheet/rpc is not ready.
        try{
          curCfg = getDefaultsForPage(pageKey);
          PB_STATE.pageKey = pageKey;
          PB_STATE.cfg = curCfg;
          buildForm(pageKey, curCfg);
        }catch(_e2){}
        setStatus('Loaded (default)');
        toast('Load failed (using defaults)', false);
      }
    }

    function doPreview(){
      var pageKey = sel ? sel.value : 'deposit';
      var cfg = readFormIntoCfg(pageKey, curCfg || getDefaultsForPage(pageKey));
      PB_STATE.pageKey = pageKey;
      PB_STATE.cfg = cfg;
      PB_STATE.pageKey = pageKey;
      PB_STATE.cfg = cfg;
      try{
        if(w.SLB_applyPageCfgPreview) w.SLB_applyPageCfgPreview(pageKey, cfg);
        toast('Preview applied (not saved)', true);
      }catch(e){
        console.error(e);
        toast('Preview failed', false);
      }
    }

    async function doSave(){
      var pageKey = sel ? sel.value : 'deposit';
      var cfg = readFormIntoCfg(pageKey, curCfg || getDefaultsForPage(pageKey));
      PB_STATE.pageKey = pageKey;
      PB_STATE.cfg = cfg;
      setStatus('Saving…');
      // Lock UI so it's obvious something is happening
      try{
        if(btnS) btnS.disabled = true;
        if(btnP) btnP.disabled = true;
        if(btnL) btnL.disabled = true;
        if(btnK) btnK.disabled = true;
        if(btnS) btnS.textContent = 'Saving…';
      }catch(_e){}
      try{
        var requestId = 'PB_' + Math.random().toString(36).slice(2) + Date.now();
        var r = await rpc('adminPageCfgSave', { pageKey: pageKey, config: cfg, requestId: requestId });
        curCfg = cfg;
        setStatus('Saved');
        toast('Saved (v' + (r && r.version ? r.version : '?') + ')', true);
        try{ if(w.SLB_applyPageCfgPreview) w.SLB_applyPageCfgPreview(pageKey, cfg); }catch(_e2){}
      }catch(e){
        console.error(e);
        setStatus('Error');
        toast('Save failed', false);
      }finally{
        try{
          if(btnS) btnS.disabled = false;
          if(btnP) btnP.disabled = false;
          if(btnL) btnL.disabled = false;
          if(btnK) btnK.disabled = false;
          if(btnS) btnS.textContent = 'Save';
        }catch(_e3){}
      }
    }

    var btnL = el('slbPageBuilderLoadBtn');
    var btnP = el('slbPageBuilderPreviewBtn');
    var btnS = el('slbPageBuilderSaveBtn');
    if(btnL) btnL.addEventListener('click', function(){ doLoad(); });
    if(btnP) btnP.addEventListener('click', function(){ doPreview(); });
    if(btnS) btnS.addEventListener('click', function(){ doSave(); });

    var btnK = el('slbPageBuilderPickBtn');
    if(btnK) btnK.addEventListener('click', function(){
      var pageKey = sel ? sel.value : 'deposit';
      if(!curCfg) curCfg = getDefaultsForPage(pageKey);
      // keep UI form in sync
      try{ curCfg = readFormIntoCfg(pageKey, curCfg); }catch(_e){}
      startPickMode(pageKey, curCfg);
    });


    // Load on first open
    doLoad();
  }

  // Init on demand (tab open)
  function bootWhenVisible(){
    var panel = el('slbPageBuilderPanel');
    if(!panel) return;
    // If already visible (rare), init immediately
    if(!panel.classList.contains('hidden')) initOnce();

    // Watch for tab open: core router calls features.onOpen(tab)
    try{
      if(w.SLB && w.SLB.features){
        w.SLB.features.register('pageBuilder', { onOpen: function(){ initOnce(); } });
      }
    }catch(_e){}
  }

  bootWhenVisible();
})(window);

